module.exports = __webpack_public_path__ + "img/productDefaultImg.48548d0a.svg";